import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import usePublicApi from 'public-api';
import { useAsyncFunction } from 'stores/hooks';
import AuthCard from 'ui-brand/components/AuthCard';

import SupportNote from '../components/SupportNote';

type RouteParams = {
  platformIntegrationId: string;
};

function ShoptetPlatformIntegrationEmail() {
  const { platformIntegrationId } = useParams<RouteParams>();
  const [email, setEmail] = useState<string | null>(null);
  const api = usePublicApi();

  const load = async () => {
    const response = await api.OnboardingPlatformIntegrationApi.retrieve({ id: platformIntegrationId! });
    setEmail(response.prefill.email);
  };
  const [handleLoad] = useAsyncFunction(load);

  useEffect(() => {
    handleLoad();
  }, []);

  return (
    <AuthCard
      title={gettext('Check your email')}
      subtitle={gettext(
        'Your Shoptet add-on is installed. To create your Retino account, follow the instructions we sent to:',
      )}
    >
      <p className="mt-6 rounded-xl bg-retino-beige px-4 py-3 text-center text-base font-semibold text-retino-darkviolet">
        {email}
      </p>
      <SupportNote />
    </AuthCard>
  );
}

export default ShoptetPlatformIntegrationEmail;
